import {ReactNode} from "react";
import {
    RenderableDocument,
    DibJsonNode,
    ElementDataReferences,
    RenderNodeOptions,
} from "../types";
import {SectionIconLinksLEGACY} from "./SectionIconLinksLEGACY";

const test = (node: DibJsonNode, options: RenderNodeOptions) => {
    const references = (node.elementData as ElementDataReferences | null)
        ?.references;
    return !!references && !options?.skipAugmentations;
};

const processor = (
    node: DibJsonNode,
    topicData: RenderableDocument,
    renderedChildren: ReactNode[]
) => {
    return [
        <SectionIconLinksLEGACY
            key={`${node.element?.attributes?.id}-sectionIconLinks`}
            node={node}
            topicData={topicData}
            renderedChildren={renderedChildren}
        />,
    ];
};

export const sectionIconLinksLEGACY = {test, processor};
